module.exports = __webpack_public_path__ + "static/media/MemMap_LPL_Financial_Logo.8bc7c989.png";